<template>
  <!--
      	作者：gmshop
      	时间：2019-06-04
      	描述：插件中心-分销-分销设置-分销商条件
      -->
  <div class="product-add mt30">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <el-form-item label="成为分销商条件">
        <div>
          <el-radio v-model="form.become" label="10">申请：需后台审核</el-radio>
          <el-radio v-model="form.become" label="20">申请：无需审核</el-radio>
          <el-radio v-model="form.become" label="30">无条件成为分销商</el-radio>
          <el-radio v-model="form.become" label="40">购买指定商品成为分销商</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="申请是否开启等级选择" v-if="form.become==10">
        <div>
          <el-radio v-model="form.open_grade" label="0">不开启</el-radio>
          <el-radio v-model="form.open_grade" label="1">开启</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="申请门槛" prop="order_price">
        <el-input v-model="form.order_price" type="number" min="0" class="max-w460">
          <template slot="append">
              元
            </template>
        </el-input>
        <div class="gray9">必须累计消费达到该金额才能申请</div>
      </el-form-item>
      

      <el-form-item label="选择审核升级等级： ">
        <el-select v-model="form.apply_grade" placeholder="请选择" style="width: 250px">
          <el-option v-for="(item,index) in gradeList" :key="index" :label="item.name"  :value="item.grade_id">
          </el-option>
        </el-select>
        <div>用户申请后会自动成为该等级身份</div>
      </el-form-item>

      <el-form-item label="购买指定商品成为分销商"  v-if="form.become==40">
        <div class="tips">购买指定商品付款后自动成为分销商，无需后台审核</div>
        <el-button type="primary" @click="openProduct">选择商品</el-button>
        <el-table size="mini" :data="form.product_image" border  style="width: 600px;">
          <el-table-column width="70" label="商品图片">
            <template slot-scope="scope">
              <img :src="scope.row.image" width="30" height="30" />
            </template>
          </el-table-column>
          <el-table-column prop="product_name" width="300" label="商品名称"></el-table-column>
          <el-table-column prop="category_name" label="商品分类"></el-table-column>
          <el-table-column label="操作" :width="70">
            <template slot-scope="scope">
              <el-button @click="deleteFunc(scope.$index)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>

      <el-form-item label="成为下线条件">
        <div>
          <el-radio v-model="form.downline" label="10">首次点击分享链接</el-radio>
          <el-radio v-model="form.downline" label="30">首次付款</el-radio>
          </div>
      </el-form-item>
      <el-form-item label="购买是否需要上级邀请人">
        <div>
          <el-radio v-model="form.need_referee_id" label="0">不需要</el-radio>
          <el-radio v-model="form.need_referee_id" label="10">需要</el-radio>
           <div class="tips">设置为需要后，默认会员购买需要有上级邀请人才能购物</div>
        </div>
      </el-form-item>

      <el-form-item label="申请页面文案" v-if="!loading">
        <div class="edit_container">
          <Uediter v-model="form.content" id="ue" :text="form.content" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper"><el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button></div>
    </el-form>
    <!--产品列表弹出层组件-->
    <Product :isproduct="isproduct" @closeDialog="closeDialogFunc($event)">产品列表弹出层</Product>
  </div>
</template>

<script>
import PlusApi from '@/api/plus.js';
import Product from '@/components/product/Product';
import Uediter from '@/components/UE.vue';
export default {
  components: {
    /*产品列表组件*/
    Product: Product,
    Uediter
  },
  data() {
    return {
      /*切换菜单*/
      // activeIndex: '1',
      /*form表单数据*/
      form: {},
      gradeList:[],
      /*是否打开产品弹出层*/
      isproduct: false,
      loading: false,
      ueditor: {
          text: '',
          config: {
            initialFrameWidth: 400,
            initialFrameHeight: 500
          }
        },
    };
  },
  props: {
    settingData: Object
  },
  created() {
    this.form = this.settingData.data.condition.values;
    this.gradeList = this.settingData.gradeList;
    if (!this.form.product_image) {
      this.form.product_image = [];
    }
  },

  methods: {
    /*提交表单*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = this.form;
      params.content = this.$refs.ue.getUEContent();
      if (params.become == 40 && params.become__buy_product_ids == '') {
        self.$message({
          message: '请选择商品',
          type: 'error'
        });
        self.loading = false;
        return false;
      }
      PlusApi.condition(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，设置成功',
            type: 'success'
          });
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*删除商品*/
    deleteFunc(i) {
      this.form.become__buy_product_ids.splice(i, 1);
      this.form.product_image.splice(i, 1);
    },

    /*产品列表弹出层*/
    openProduct() {
      this.isproduct = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e) {
      this.isproduct = e.openDialog;
      if (e.type == 'success') {
        if (this.form.become__buy_product_ids.indexOf(e.params.product_id) == -1) {
          this.form.become__buy_product_ids.push(e.params.product_id);
          this.form.product_image.push({ product_id: e.params.product_id, image: e.params.image,product_name: e.params.product_name,category_name: e.params.category.name });
        } else {
          this.$message({
            message: '已选择该商品',
            type: 'warning'
          });
        }
      }
    }
  }
};
</script>

<style scoped="scoped">
.tips {
  color: #ccc;
}

.img {
  width: 100px;
  margin-top: 10px;
  height: 130px;
  margin-right: 10px;
}

.img img {
  border: 1px solid #eeeeee;
}

.delete-btn {
  position: absolute;
  display: block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  right: -8px;
  top: -8px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/agent/setting/part/Condition.vue